import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FellowForm from '../../../components/forms/FellowForm';
import { useCreateFellow } from '../../../hooks/useFellowApi';
import { useNavigate } from 'react-router-dom';
import { FellowDTO } from '../../../services/apiClient';

const FellowCreate: React.FC = () => {
  const createFellow = useCreateFellow();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Fellows', href: '/admin/fellows' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FellowDTO) => {
    try {
      await createFellow.mutateAsync(data);
      navigate('/admin/fellows');
    } catch (error) {
      console.error('Error creating Fellow:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/fellows"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Fellow.Edit'
    >
      <FellowForm
        initialValues={{} as FellowDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/fellows')}
      />
    </AdminLayout>
  );
};

export default FellowCreate;
